module.exports = __webpack_public_path__ + "img/avataaars (4).af429379.svg";